import { axiosInstance } from '~/services';

import type {
  TypeApiResponse,
  TypeGetInboundAreaOperationDatesParams,
  TypeGetInboundAreaOperationDatesResponse,
} from '~/types/receive.types';

/**
 * [입고요청관리] 입고(예약)가능일자 목록 조회 API
 */
export const fetchInboundAreaOperationDates = async (
  params: TypeGetInboundAreaOperationDatesParams
): Promise<TypeGetInboundAreaOperationDatesResponse> => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetInboundAreaOperationDatesResponse>>(
    '/api-inbound/v1/3pl/inbound-area/operation-dates',
    { params }
  );
  return data.data;
};
